import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SortPipe } from './../../_helpers/_pipes/sort.pipe';

@Injectable({
  providedIn: 'root',
})
export class AutopayBillingService {
  private withdrawalData = new BehaviorSubject<any>(null);
  private displayAutopayalert = new BehaviorSubject<boolean>(false);

  constructor(private sort: SortPipe) {}

  getSortedPlannedBills(policy) {
    const plannedInvoices = policy.scheduleBills.filter(
      (scheduledBill) => scheduledBill.invoiceState === 'Planned'
    );
    return this.sort.transform(plannedInvoices, 'dateDue', 'asc');
  }
  getSortedBills(policy) {
    const sortedInvoices = policy.scheduleBills.filter(
      (scheduledBill) =>
        scheduledBill.invoiceState === 'Planned' ||
        scheduledBill.invoiceState === 'Billed'
    );
    return this.sort.transform(sortedInvoices, 'dateDue', 'asc');
  }
  setWithdrawalData(data) {
    this.withdrawalData.next(data);
  }
  getWithdrawalData() {
    return this.withdrawalData.asObservable();
  }
  setAutopayAlert(flag) {
    this.displayAutopayalert.next(flag);
  }
  getAutopayAlert() {
    return this.displayAutopayalert.asObservable();
  }
}
